import { useTranslation } from '@gimlite/common';
import { observer } from 'mobx-react-lite';
import { Col } from '../components/col/col.component';
import { Page } from '../components/page/page.component';
import { Status } from '../components/status/status.component';
import { Text } from '../components/text/text.component';

export const Page404 = observer(() => {
  const { t } = useTranslation();

  return (
    <Page>
      <Col height="100%" alignItems="center" justifyContent="center" gap={16}>
        <Col alignItems="center" justifyContent="center" gap={8}>
          <Status
            icon="alarm"
            backgroundColor="black_4"
            foregroundColor="black_50"
          />
          <Col alignItems="center" justifyContent="center">
            <Text variant="headline">{t('watermelon-404_TITLE')}</Text>
            <Text variant="body">{t('watermelon-404_DESCRIPTION')}</Text>
          </Col>
        </Col>
      </Col>
    </Page>
  );
});
